// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__mrKlo","gfeWrapper":"CalendarEvent_gfeWrapper__1oWE_"};